'use strict';

angular.module('app').controller('AppCtrl', [
    '$scope',
    '$translate',
    '$localStorage',
    '$window',
    '$rootScope',
    '$http',
    '$state',
    'toaster',
    '$cookies',
    'tmhDynamicLocale',
    'csLanguage',
    '$ngConfirm',
    'DistributionService',
    'AccessManagerService',
    'VersionManagerService',
    'ReactAvaibilityService',
    function(
        $scope,
        $translate,
        $localStorage,
        $window,
        $rootScope,
        $http,
        $state,
        toaster,
        $cookies,
        tmhDynamicLocale,
        csLanguage,
        $ngConfirm,
        DistributionService,
        AccessManagerService,
        VersionManagerService,
        ReactAvaibilityService
    ) {
        function onWindowResizeCallback() {
            $rootScope.isSmartDevice = isSmartDevice($window);
        }

        angular.element($window).on('resize', function() {
            onWindowResizeCallback();
            $scope.$apply();
        });

        onWindowResizeCallback();

        $rootScope.Distribution = DistributionService;
        $rootScope.AccessManager = AccessManagerService;
        $rootScope.VersionManager = VersionManagerService;
        $rootScope.ReactAvaibility = ReactAvaibilityService;

        $rootScope.mobileNavigationOn = false;

        $rootScope.isMobileNavigationOn = function() {
            return $rootScope.mobileNavigationOn;
        };

        $rootScope.setMobileNavigationOn = function(value) {
            $rootScope.mobileNavigationOn = value;
        };

        var isIE = !!navigator.userAgent.match(/MSIE/i);

        if (isIE) {
            angular.element($window.document.body).addClass('ie');
        }

        if ($rootScope.isSmartDevice) {
            angular.element($window.document.body).on('gesturestart', function(e) {
                e.preventDefault();
            });
        }

        var currentDate = new Date();

        $scope.app = {
            name: 'Widzisz Wszystko',
            settings: {
                year: currentDate.getFullYear(),
                cache: false,
            },
            user: {
                loginId: '',
                clientId: '',
                roleId: '',
                user: '',
                masterGroupId: '',
                code: '',
                email: '',
                extraFeatures: [],
                notifications: {
                    results: [],
                    counts: {
                        all: 0,
                        unreaded: 0,
                    },
                },
                groups: {
                    main: {},
                    others: {},
                    shared: {},
                    logins: {},
                },
                reports: {
                    types: [],
                },
            },
            group: {
                id: -1,
                type: 'group',
                model: 'g-1',
                default: 'g-1',
                list: [],
                objects: [],
                init: false,
            },
            sort: {
                column: false,
                type: false,
            },
        };

        $rootScope.$on('$translateLoadingSuccess', function() {
            VersionManagerService.load().then(
                function(data) {
                    if (!data) {
                        return false;
                    }

                    toaster.pop({
                        type: 'info',
                        title: $translate.instant('version.actualization.title'),
                        body:
                            $translate.instant('version.actualization.text', {
                                version: VersionManagerService.current(),
                            }) +
                            ' ' +
                            '<a href="/versions" target="_blank">' +
                            $translate.instant('version.actualization.click') +
                            '</a>',
                        timeout: 8000,
                        bodyOutputType: 'trustedHtml',
                    });
                },
                function() {}
            );
        });

        $scope.isEmpty = function(obj) {
            return Object.keys(obj).length === 0;
        };

        $rootScope.app = $scope.app;

        $rootScope.$on('updateUserData', function(e, data) {
            $scope.app.user = data;
            $scope.app.group.list = $scope.buildObjectsGroupsList();

            AccessManagerService.update($scope.app.user);

            var group = $scope.getObjectsGroupByCookie($scope.app.user.loginId);
            $scope.app.group.model = flatObjectGroup(group);
            $scope.chooseObjectsGroup(group, false);
        });

        $rootScope.$on('showAccessPermissionMessage', function() {
            toaster.pop({
                type: 'info',
                title: $translate.instant('access.minimum.header'),
                body: $translate.instant('access.minimum.body'),
                timeout: 8000,
            });
        });

        $scope.gotoReportTypeForm = function(type) {
            $state.go('app.report', { type: type });
        };

        $scope.gotoAllObjectsTab = function() {
            $state.go('app.object', { all: true }, { reload: true });
        };

        if ($scope.app.settings.cache && angular.isDefined($localStorage.settings)) {
            $scope.app.settings = $localStorage.settings;
        } else {
            $localStorage.settings = $scope.app.settings;
        }

        /*
         * language setter /getter - priority list
         * - browser language
         * - cookie
         */

        $scope.selectedLanguage = csLanguage.get('lang');
        $scope.availableLanguages = csLanguage.getAvailable();

        csLanguage.settle('lang', $scope.selectedLanguage);

        $scope.customChooseLanguage = function(value) {
            $scope.chooseLanguage(value);
        };

        $scope.chooseLanguage = function(value) {
            $scope.selectedLanguage = value;
            csLanguage.settle('lang', value);
        };

        $scope.changeLanguageSettings = function(value) {
            $scope.selectedLanguage = value;
            $translate.use(value);
            moment.locale(value);
            tmhDynamicLocale.set(value);
        };

        $scope.$watch('selectedLanguage', function(n) {
            n && $scope.changeLanguageSettings(n);
        });

        /*
         * language section - end
         */

        /*
         * groups management
         * - selected group - app.group.objects
         * - group with all objects - app.user.groups.all.objects
         * - cookie for saved choose (objects-group-{login})
         */

        $scope.initObjectsGroupsSwitching = function() {
            $scope.app.group.init = true;
        };

        $scope.buildObjectsGroupsList = function() {
            var list = [];

            list.push({
                value: $scope.app.group.default,
                label: $translate.instant('aside.groups.all'),
                class: 'nbs-option-shared',
                selected: false,
            });

            Object.values($scope.getObjectsGroups(['others', 'shared'])).map(function(o) {
                list.push({
                    value: 'g' + o.groupId,
                    label: o.name,
                    class: 'nbs-option-' + o.groupType,
                    selected: o.groupId === 667 ? true : false,
                });
            });

            Object.values($scope.getObjectsGroups(['logins'])).map(function(o) {
                list.push({
                    value: 'l' + o.loginId,
                    label: o.name,
                    class: 'nbs-option-' + o.groupType,
                    selected: false,
                });
            });

            return list;
        };

        function flatObjectGroup(g) {
            return (g.type === 'login' ? 'l' : 'g') + String(g.id);
        }

        function deepObjectGroup(n) {
            var result = false;
            if (n) {
                var type = false;
                var num = false;
                if (isNaN(n)) {
                    var l = n.substr(1);
                    num = Number(l);
                    type = n.substr(0, 1) === 'l' ? 'login' : 'group';
                } else {
                    type = 'group';
                    num = n;
                }
                if (num && !isNaN(num)) {
                    return {
                        type: type,
                        id: Number(num),
                    };
                }
            }
            return result;
        }

        function _updateGroupModel(n, o) {
            if (!$scope.app.group.init) {
                return false;
            }

            if (n !== o) {
                var st = deepObjectGroup(n);

                $scope.app.group.type = st.type;
                $scope.app.group.id = st.id;

                $scope.setObjectsGroupCookie($scope.app.user.loginId, st, n);
                $scope.chooseObjectsGroup(st, true);
            }
        }

        $scope.$watch('app.group.model', function(n, o) {
            _updateGroupModel(n, o);
        });

        $scope.validateAccessToObjectsGroup = function(st) {
            var options = {
                groups: ['main', 'others', 'shared'],
                field: 'groupId',
            };

            if (st.type === 'login') {
                options = {
                    groups: ['logins'],
                    field: 'loginId',
                };
            }

            var groups = $scope.getObjectsGroups(options.groups);

            groups = Object.values(groups).map(function(g) {
                return g[options.field];
            });
            return groups.indexOf(st.id) >= 0;
        };

        $scope.getObjectsGroupByCookie = function(l) {
            var cookie = $cookies.get('objects-group-' + String(l));
            var result = deepObjectGroup($scope.app.group.default);

            if (cookie !== void 0) {
                var st = deepObjectGroup(cookie);
                if (!st) {
                    return result;
                }

                return $scope.validateAccessToObjectsGroup(st) ? st : result;
            }
            return result;
        };

        $scope.setObjectsGroupCookie = function(l, g, c) {
            if ($scope.validateAccessToObjectsGroup(g)) {
                var expiration = new Date();
                expiration.setDate(expiration.getDate() + 365);

                $cookies.put('objects-group-' + String(l), c, {
                    expires: expiration,
                });
            }
        };

        $scope.customChooseObjectsGroup = function(n) {
            $scope.app.group.init = true;

            var o = $scope.app.group.model;
            $scope.chooseObjectsGroup(n, false);

            _updateGroupModel(n, o);

            $scope.app.group.model = n;
        };

        $scope.chooseObjectsGroup = function(st, reload) {
            if (!st) {
                return false;
            }

            reload && deleteObjectFilteringCookies();

            $scope.app.group.type = st.type;
            $scope.app.group.id = st.id;

            reload && $rootScope.$broadcast('reloadGroupObjects', { group: st.id });
        };

        $scope.extractObjectsByGroupTypes = function(types) {
            var groups = $scope.getObjectsGroups(types);
            var objects = [];
            var used = [];

            for (var p in groups) {
                if (groups.hasOwnProperty(p)) {
                    objects = objects.concat(
                        groups[p].objects.filter(function(o) {
                            return used.indexOf(o.objectId) < 0;
                        })
                    );
                    used = objects.map(function(o) {
                        return o.objectId;
                    });
                }
            }
            return objects;
        };

        /*
         * extractObjectsByGroupId - function take all objects from
         * specify group, if first argument is set to true function
         * will not return objects from shared group
         *
         * @param bool owner
         * @param string type - login | group
         * @param int id
         * @returns []
         */

        $scope.extractObjectsByGroupId = function(owner, type, id) {
            var own = owner === void 0 ? false : owner;
            var id = id === void 0 ? $scope.app.group.id : id;

            var types = [];

            if (type === 'group') {
                types = ['main', 'others'];
                !own && types.push('shared');
            } else {
                types = ['logins'];
            }

            var groups = $scope.getObjectsGroups(types);
            for (var p in groups) {
                if (groups.hasOwnProperty(p)) {
                    var g = groups[p];
                    var field = type === 'login' ? 'loginId' : 'groupId';

                    if (g[field] === id) {
                        return g.objects;
                    }
                }
            }
            return [];
        };

        $scope.extractObjectsBySelectedGroup = function(owner, logins) {
            var objects = [];
            var own = owner === void 0 ? false : owner;

            if ($scope.app.group.id >= 0) {
                if (!($scope.app.group.type === 'login') || logins) {
                    objects = $scope.extractObjectsByGroupId(own, $scope.app.group.type, $scope.app.group.id);
                }
            } else {
                objects = $scope.extractAllUserObjects(own, logins);
            }
            return objects;
        };

        $scope.extractAllUserObjects = function(owner, logins) {
            var own = owner === void 0 ? false : owner;
            var types = ['main', 'others'];

            if (!own) {
                types.push('shared');
            }
            logins && types.push('logins');

            return $scope.extractObjectsByGroupTypes(types);
        };

        $scope.extractAllUserGroupsAndObjects = function(owner) {
            var list = $scope.extractAllUserObjects(owner, false);
            list = list.map(function(o) {
                o.type = 'object';
                return o;
            });
            var groups = Object.values($scope.getObjectsGroups(['others']));
            groups = groups.map(function(o) {
                o.type = 'group';
                return o;
            });

            return groups.concat(list);
        };

        /*
         * getObjectsGroups - merge all groups specified by group types
         * possible values
         * - main - one group containing all login objects
         * - groups - all login groups
         * - shared - groups shared for login
         *
         * @param [] types
         * @returns []
         */

        $scope.getObjectsGroups = function(types) {
            var groups = {};
            for (var i = 0; i < types.length; i++) {
                var readed = $scope.app.user.groups[types[i]];
                if (types[i] === 'main') {
                    readed = { 0: readed };
                }
                groups = Object.assign({}, groups, readed);
            }
            return groups;
        };

        function deleteObjectFilteringCookies() {
            $cookies.remove('object-filtering');
        }

        function updateObjectFilteringCookies(selected) {
            var expiration = new Date();
            expiration.setDate(expiration.getDate() + 365);

            for (var id in selected) {
                if (selected.hasOwnProperty(id) && !selected[id]) {
                    delete selected[id];
                }
            }

            $cookies.put('object-filtering', JSON.stringify(selected), {
                expires: expiration,
            });
            return true;
        }

        $scope.getObjectFilteringResults = function() {
            var selected = [];
            var stored = $cookies.get('object-filtering');

            if (stored !== void 0) {
                selected = Object.keys(JSON.parse(stored));
                if (!selected.length) {
                    return false;
                }
                selected = selected.map(function(v) {
                    return Number(v);
                });
            } else {
                return false;
            }

            var objects = getSelectedGroupObjectsList();
            var result = [];

            for (var i = objects.length - 1; i >= 0; i--) {
                var o = objects[i];
                if (selected.indexOf(o.objectId) >= 0) {
                    result.push(o.objectId);
                }
            }

            return result;
        };

        function getSelectedGroupObjectsList() {
            var gid = $scope.app.group.id;
            var type = $scope.app.group.type;
            var groups = $scope.app.user.groups;
            var objects = [];

            if (type === 'login') {
                objects = groups.logins[gid].objects;
            } else if (gid === -1) {
                objects = $scope.extractAllUserObjects(true, true);
            } else {
                if (groups.others[gid] !== void 0) {
                    objects = groups.others[gid].objects;
                } else if (groups.shared[gid] !== void 0) {
                    objects = groups.shared[gid].objects;
                }
            }
            return objects;
        }

        /**
         * Modal for filtering (show / hide) objects
         */
        $scope.openObjectFilteringModal = function() {
            var $isolated = $scope.$new(true);

            var objects = getSelectedGroupObjectsList();
            var selected = {};
            var stored = $cookies.get('object-filtering');

            if (stored !== void 0) {
                selected = JSON.parse(stored);
            }

            $isolated.data = {
                all: false,
                filter: '',
                order: {
                    field: 'number',
                    reverse: false,
                },
                sort: function(field) {
                    if (field !== this.order.field) {
                        this.order.reverse = false;
                    } else {
                        this.order.reverse = !this.order.reverse;
                    }
                    this.order.field = field;
                },
                selected: selected,
                objects: objects,
                toggleAll: function() {
                    var all = this.all;
                    for (var i = 0; i < this.objects.length; i++) {
                        var o = this.objects[i];
                        if (all) {
                            this.selected[o.objectId] = true;
                        } else {
                            delete this.selected[o.objectId];
                        }
                    }
                },
            };

            $ngConfirm({
                title: $translate.instant('object-filtering.header'),
                contentUrl: 'tpl/layouts/components/object-filtering.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'fas fa-car',
                scope: $isolated,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-success',
                        action: function(scope) {
                            updateObjectFilteringCookies(scope.data.selected);
                            $state.go($state.current, {}, { reload: true });
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        /**
         * Multiple sign in functionality
         */
        $scope.isUserMultipleLoggedIn = function() {
            return !angular.equals($rootScope.app.user.groups.logins, []);
        };

        $scope.getUserMultipleLoginAccounts = function() {
            var logins = [];
            angular.forEach($rootScope.app.user.groups.logins, function(v, k) {
                logins.push(v.name);
            });
            return logins;
        };

        $scope.openMultipleLoginModal = function() {
            var $isolated = $scope.$new(true);

            $http.get('/api/multiple').then(
                function(response) {
                    var accounts = response.data.data;
                    var instance = null;

                    $isolated.data = {
                        accounts: accounts,
                        form: {
                            login: '',
                            password: '',
                        },
                        signIn: function(form) {
                            $http.post('/api/multiple', form).then(
                                function() {
                                    instance.close();
                                    $state.go($state.current, {}, { reload: true });
                                },
                                function(error) {
                                    var code = error.status === 400 ? 'signin' : 'general';
                                    toaster.error(
                                        $translate.instant('general.toastr.error.header'),
                                        $translate.instant('multiple-login.toastr.error.' + code)
                                    );
                                }
                            );
                        },
                        signOut: function(account) {
                            $http.delete('/api/multiple/' + account.id).then(function() {
                                instance.close();
                                $state.go($state.current, {}, { reload: true });
                            });
                        },
                    };

                    instance = $ngConfirm({
                        title: $translate.instant('multiple-login.header'),
                        contentUrl: 'tpl/layouts/components/multiple-login.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'medium',
                        icon: 'fas fa-user-tie',
                        scope: $isolated,
                        buttons: {
                            no: {
                                text: $translate.instant('general.confirm.close'),
                                btnClass: 'btn-warning',
                            },
                        },
                    });
                },
                function() {}
            );
        };

        /**
         * watcher for objects groups
         */
        $scope.$on('reloadGroupObjects', function(e, a) {
            $scope.app.group.init = false;
            $state.go($state.current, { group: a.group }, { reload: true });
        });

        /*
         * groups management - end
         * -----------------------------------------------------------
         */

        /**
         * function broadcast reloading objects for desktop / mobile
         *
         * @param {bool} desktop
         */
        $scope.reloadObjects = function(desktop) {
            $scope.$broadcast('reloadObjects', { desktop: desktop });
        };

        /**
         * watcher for update notification counts
         */
        $scope.$on('reloadNotificationCounter', function(e, a) {
            $scope.app.user.notifications.counts = a.counts;
        });

        /**
         * Report categories
         */
        $scope.reportCategory = {
            selected: {},
            choose: function(key) {
                this.selected[key] = !this.isSelected(key);
            },
            isSelected: function(key) {
                return this.selected[key] ? this.selected[key] : false;
            },
        };

        $rootScope.$on('broadcastTollInstruction', function(e, data) {
            $scope.showTollInstruction = data;
        });

        $scope.showTollInstruction = true;

        $scope.tollInstructionRemove = function() {
            $scope.showTollInstruction = false;
        };

        /**
         * Manually invoke close moment picker for mobile devices
         */
        var customClickHandler = false;
        angular.element(document).on('touchstart', function() {
            customClickHandler = true;
        });
        angular.element(document).on('touchmove', function() {
            customClickHandler = false;
        });
        angular.element(document).on('click touchend', function(event) {
            if (event.type === 'click') {
                customClickHandler = true;
            }
            var target = angular.element(event.target);
            if (customClickHandler) {
                var target = angular.element(event.target);
                if (
                    !target.is('button') &&
                    !target.is('.moment-picker-input') &&
                    !target.parents('.moment-picker').length
                ) {
                    angular.element(document.getElementsByClassName('moment-picker-input')).trigger('blur');
                }
            }
        });

        $rootScope.$on('sessionDied', function() {
            $state.go('access.login');
        });
    },
]);

function isSmartDevice($window) {
    var ua = $window.navigator.userAgent || $window.navigator.vendor || $window.opera;
    return /iPhone|iPod|iPad|Silk|webOS|Android|BlackBerry|Opera Mini|IEMobile/.test(ua);
}

angular.module('app').factory('HttpResponseHooks', [
    '$q',
    '$rootScope',
    function($q, $rootScope) {
        var deferred = $q.defer();
        return {
            request: function(config) {
                if (typeof config.displayButterbar !== 'undefined' ? config.displayButterbar : true) {
                    $rootScope.$broadcast('$loadingDataStart');
                }
                return config || deferred.when(config);
            },
            response: function(response) {
                $rootScope.$broadcast('$loadingDataSuccess');
                return response;
            },
            responseError: function(rejection) {
                $rootScope.$broadcast('$loadingDataSuccess');

                if (rejection.status === 403) {
                    if (rejection.data.logged !== void 0 && !rejection.data.logged) {
                        $rootScope.$broadcast('sessionDied');
                    }
                }

                return $q.reject(rejection);
            },
        };
    },
]);
